import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const IndexPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/dashboard");
  });
  return <div></div>;
};

export default IndexPage;
